import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

// components
import { SignCompleteComponent } from './sign-complete.component';

// services

// modules
import { SharedModule } from '../../../../../coverpath-common/angular/components/shared/shared.module';

@NgModule({
  declarations: [SignCompleteComponent],
  imports: [RouterModule, CommonModule, SharedModule],
  exports: [SignCompleteComponent],
})
export class SignCompleteModule {}
